// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Tabletop Trail - Tavern Theme Design System
 * Version: 1.0
 * Date: January 12, 2026
 * Based on: docs/design/tavern-theme/design-system.md
 */

:root {
  /* ========== Colors - Primary (Fire) ========== */
  --color-fire-700: #8f3a0b;
  --color-fire-600: #b8470e;
  --color-fire-500: #d85a1f;
  --color-fire-400: #f36e30;

  /* ========== Colors - Background (Wood) ========== */
  --color-wood-900: #1a1410;
  --color-wood-800: #2d2218;
  --color-wood-700: #3e2f22;
  --color-wood-600: #4f3d2d;

  /* ========== Colors - Content (Parchment) ========== */
  --color-parchment-100: #f5efe7;
  --color-parchment-200: #e8dbc8;
  --color-parchment-300: #d4c4a8;

  /* ========== Colors - Semantic ========== */
  --color-success-100: #e8f3eb;
  --color-success-500: #4a7c59;
  --color-success-600: #3a6347;
  --color-success-700: #2d4d38;
  --color-warning-100: #fdf5e6;
  --color-warning-400: #e0ba63;
  --color-warning-500: #d4a74a;
  --color-warning-600: #b8923e;
  --color-warning-700: #967632;
  --color-danger-500: #a8342a;
  --color-danger-600: #8a2b23;
  --color-info-500: #4a6b8a;
  --color-info-600: #3b5570;
  --color-nature-100: #e8f3eb;
  --color-nature-600: #4a7c59;
  --color-nature-700: #3a6347;

  /* ========== Colors - Text ========== */
  --color-text-primary: #1a1410;
  --color-text-primary-light: #f5efe7;
  --color-text-secondary: #4f3d2d;
  --color-text-secondary-light: #d4c4a8;
  --color-text-tertiary: #8b7355;
  --color-text-disabled: #a69580;

  /* ========== Typography ========== */
  --font-heading: 'Cinzel', Georgia, serif;
  --font-body: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  --font-decorative: 'IM Fell English', Georgia, serif;

  /* Font Sizes */
  --font-size-h1: 28px;
  --font-size-h1-mobile: 24px;
  --font-size-h2: 22px;
  --font-size-h2-mobile: 20px;
  --font-size-h3: 18px;
  --font-size-h3-mobile: 16px;
  --font-size-body-lg: 16px;
  --font-size-body: 14px;
  --font-size-body-sm: 12px;
  --font-size-caption: 11px;

  /* Line Heights */
  --line-height-h1: 32px;
  --line-height-h1-mobile: 28px;
  --line-height-h2: 28px;
  --line-height-h2-mobile: 24px;
  --line-height-h3: 24px;
  --line-height-h3-mobile: 22px;
  --line-height-body-lg: 24px;
  --line-height-relaxed: 1.6;
  --line-height-body: 20px;
  --line-height-body-sm: 16px;
  --line-height-caption: 14px;

  /* Font Weights */
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;

  /* ========== Spacing ========== */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 24px;
  --space-6: 32px;
  --space-7: 48px;
  --space-8: 64px;

  /* ========== Border Radius ========== */
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-full: 9999px;

  /* ========== Shadows ========== */
  --shadow-sm: 0 2px 4px rgba(26, 20, 16, 0.15);
  --shadow-md: 0 2px 8px rgba(26, 20, 16, 0.15);
  --shadow-lg: 0 8px 32px rgba(26, 20, 16, 0.4);
  --shadow-nav: 0 -4px 12px rgba(0, 0, 0, 0.3);
  --shadow-card: 0 3px 12px rgba(26, 20, 16, 0.2), inset 0 2px 0 rgba(245, 239, 231, 0.8);
  --shadow-card-hover: 0 6px 20px rgba(26, 20, 16, 0.25), inset 0 2px 0 rgba(245, 239, 231, 0.8);
  --shadow-modal: 0 8px 32px rgba(26, 20, 16, 0.4), inset 0 2px 0 rgba(245, 239, 231, 0.8);
  --shadow-button: 0 2px 4px rgba(26, 20, 16, 0.3);

  /* ========== Transitions ========== */
  --transition-fast: 150ms;
  --transition-normal: 250ms;
  --transition-slow: 350ms;
  --transition-timing: ease-out;

  /* ========== Z-Index Layers ========== */
  --z-base: 1;
  --z-header: 10;
  --z-sticky: 20;
  --z-dropdown: 100;
  --z-overlay: 200;
  --z-modal: 300;
  --z-notification: 400;

  /* ========== Layout ========== */
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --nav-height: 60px;
  --sidebar-width: 240px;
  --content-max: 1024px;
  --notification-height: 44px;
}

/* ========== Global Base Styles ========== */
/* Body background (wood texture) is defined in _base.css to avoid duplication. */
body {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  line-height: var(--line-height-body);
}

/* ========== Animations ========== */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fade-in-scale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slide-down {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ========== Utility Classes ========== */
.fade-in {
  animation: fade-in var(--transition-slow) var(--transition-timing);
}

.fade-in-up {
  animation: fade-in-up var(--transition-slow) var(--transition-timing);
}

.fade-in-down {
  animation: fade-in-down var(--transition-slow) var(--transition-timing);
}

.fade-in-scale {
  animation: fade-in-scale var(--transition-slow) var(--transition-timing);
}

/* ========== Responsive Breakpoints ========== */
@media (max-width: 375px) {
  :root {
    --font-size-h1: var(--font-size-h1-mobile);
    --line-height-h1: var(--line-height-h1-mobile);
    --font-size-h2: var(--font-size-h2-mobile);
    --line-height-h2: var(--line-height-h2-mobile);
    --font-size-h3: var(--font-size-h3-mobile);
    --line-height-h3: var(--line-height-h3-mobile);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/styles/tavern-theme.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,kDAAkD;EAClD,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,qDAAqD;EACrD,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,uDAAuD;EACvD,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,4CAA4C;EAC5C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,wCAAwC;EACxC,6BAA6B;EAC7B,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;EACrC,8BAA8B;EAC9B,8BAA8B;;EAE9B,qCAAqC;EACrC,wCAAwC;EACxC;uCACqC;EACrC,oDAAoD;;EAEpD,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;;EAEzB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;;EAE3B,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,kCAAkC;EAClC,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;;EAErB,kCAAkC;EAClC,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,4CAA4C;EAC5C,uFAAuF;EACvF,8FAA8F;EAC9F,wFAAwF;EACxF,gDAAgD;;EAEhD,sCAAsC;EACtC,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;;EAE7B,yCAAyC;EACzC,WAAW;EACX,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;;EAErB,iCAAiC;EACjC,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C,iFAAiF;AACjF;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,kEAAkE;AACpE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,iDAAiD;AACjD;EACE;IACE,0CAA0C;IAC1C,8CAA8C;IAC9C,0CAA0C;IAC1C,8CAA8C;IAC9C,0CAA0C;IAC1C,8CAA8C;EAChD;AACF","sourcesContent":["/**\n * Tabletop Trail - Tavern Theme Design System\n * Version: 1.0\n * Date: January 12, 2026\n * Based on: docs/design/tavern-theme/design-system.md\n */\n\n:root {\n  /* ========== Colors - Primary (Fire) ========== */\n  --color-fire-700: #8f3a0b;\n  --color-fire-600: #b8470e;\n  --color-fire-500: #d85a1f;\n  --color-fire-400: #f36e30;\n\n  /* ========== Colors - Background (Wood) ========== */\n  --color-wood-900: #1a1410;\n  --color-wood-800: #2d2218;\n  --color-wood-700: #3e2f22;\n  --color-wood-600: #4f3d2d;\n\n  /* ========== Colors - Content (Parchment) ========== */\n  --color-parchment-100: #f5efe7;\n  --color-parchment-200: #e8dbc8;\n  --color-parchment-300: #d4c4a8;\n\n  /* ========== Colors - Semantic ========== */\n  --color-success-100: #e8f3eb;\n  --color-success-500: #4a7c59;\n  --color-success-600: #3a6347;\n  --color-success-700: #2d4d38;\n  --color-warning-100: #fdf5e6;\n  --color-warning-400: #e0ba63;\n  --color-warning-500: #d4a74a;\n  --color-warning-600: #b8923e;\n  --color-warning-700: #967632;\n  --color-danger-500: #a8342a;\n  --color-danger-600: #8a2b23;\n  --color-info-500: #4a6b8a;\n  --color-info-600: #3b5570;\n  --color-nature-100: #e8f3eb;\n  --color-nature-600: #4a7c59;\n  --color-nature-700: #3a6347;\n\n  /* ========== Colors - Text ========== */\n  --color-text-primary: #1a1410;\n  --color-text-primary-light: #f5efe7;\n  --color-text-secondary: #4f3d2d;\n  --color-text-secondary-light: #d4c4a8;\n  --color-text-tertiary: #8b7355;\n  --color-text-disabled: #a69580;\n\n  /* ========== Typography ========== */\n  --font-heading: 'Cinzel', Georgia, serif;\n  --font-body: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    'Helvetica Neue', Arial, sans-serif;\n  --font-decorative: 'IM Fell English', Georgia, serif;\n\n  /* Font Sizes */\n  --font-size-h1: 28px;\n  --font-size-h1-mobile: 24px;\n  --font-size-h2: 22px;\n  --font-size-h2-mobile: 20px;\n  --font-size-h3: 18px;\n  --font-size-h3-mobile: 16px;\n  --font-size-body-lg: 16px;\n  --font-size-body: 14px;\n  --font-size-body-sm: 12px;\n  --font-size-caption: 11px;\n\n  /* Line Heights */\n  --line-height-h1: 32px;\n  --line-height-h1-mobile: 28px;\n  --line-height-h2: 28px;\n  --line-height-h2-mobile: 24px;\n  --line-height-h3: 24px;\n  --line-height-h3-mobile: 22px;\n  --line-height-body-lg: 24px;\n  --line-height-relaxed: 1.6;\n  --line-height-body: 20px;\n  --line-height-body-sm: 16px;\n  --line-height-caption: 14px;\n\n  /* Font Weights */\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n\n  /* ========== Spacing ========== */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 24px;\n  --space-6: 32px;\n  --space-7: 48px;\n  --space-8: 64px;\n\n  /* ========== Border Radius ========== */\n  --radius-sm: 4px;\n  --radius-md: 6px;\n  --radius-lg: 8px;\n  --radius-xl: 12px;\n  --radius-full: 9999px;\n\n  /* ========== Shadows ========== */\n  --shadow-sm: 0 2px 4px rgba(26, 20, 16, 0.15);\n  --shadow-md: 0 2px 8px rgba(26, 20, 16, 0.15);\n  --shadow-lg: 0 8px 32px rgba(26, 20, 16, 0.4);\n  --shadow-nav: 0 -4px 12px rgba(0, 0, 0, 0.3);\n  --shadow-card: 0 3px 12px rgba(26, 20, 16, 0.2), inset 0 2px 0 rgba(245, 239, 231, 0.8);\n  --shadow-card-hover: 0 6px 20px rgba(26, 20, 16, 0.25), inset 0 2px 0 rgba(245, 239, 231, 0.8);\n  --shadow-modal: 0 8px 32px rgba(26, 20, 16, 0.4), inset 0 2px 0 rgba(245, 239, 231, 0.8);\n  --shadow-button: 0 2px 4px rgba(26, 20, 16, 0.3);\n\n  /* ========== Transitions ========== */\n  --transition-fast: 150ms;\n  --transition-normal: 250ms;\n  --transition-slow: 350ms;\n  --transition-timing: ease-out;\n\n  /* ========== Z-Index Layers ========== */\n  --z-base: 1;\n  --z-header: 10;\n  --z-sticky: 20;\n  --z-dropdown: 100;\n  --z-overlay: 200;\n  --z-modal: 300;\n  --z-notification: 400;\n\n  /* ========== Layout ========== */\n  --safe-bottom: env(safe-area-inset-bottom, 0px);\n  --nav-height: 60px;\n  --sidebar-width: 240px;\n  --content-max: 1024px;\n  --notification-height: 44px;\n}\n\n/* ========== Global Base Styles ========== */\n/* Body background (wood texture) is defined in _base.css to avoid duplication. */\nbody {\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  line-height: var(--line-height-body);\n}\n\n/* ========== Animations ========== */\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fade-in-down {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fade-in-scale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes slide-down {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ========== Utility Classes ========== */\n.fade-in {\n  animation: fade-in var(--transition-slow) var(--transition-timing);\n}\n\n.fade-in-up {\n  animation: fade-in-up var(--transition-slow) var(--transition-timing);\n}\n\n.fade-in-down {\n  animation: fade-in-down var(--transition-slow) var(--transition-timing);\n}\n\n.fade-in-scale {\n  animation: fade-in-scale var(--transition-slow) var(--transition-timing);\n}\n\n/* ========== Responsive Breakpoints ========== */\n@media (max-width: 375px) {\n  :root {\n    --font-size-h1: var(--font-size-h1-mobile);\n    --line-height-h1: var(--line-height-h1-mobile);\n    --font-size-h2: var(--font-size-h2-mobile);\n    --line-height-h2: var(--line-height-h2-mobile);\n    --font-size-h3: var(--font-size-h3-mobile);\n    --line-height-h3: var(--line-height-h3-mobile);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
